<template>
    <div class="relative min-h-screen min-w-screen bg-white text-gray-900 flex items-center overflow-hidden">
      <div class="absolute inset-0 p-2 grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-2 transform -skew-y-12 scale-125 h-2/3 -translate-x-6">
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/plumbing-company-logo.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/easy-clean.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/padel-club.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/bootroom.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/close-shave.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/error-nogo.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/smith-graysons.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/holey-grail.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/the-angler.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/always-greener.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/proper-brewing.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/sorensa.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/austins.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/the-peveril.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/chaptters.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/eversons-electric.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/maceys-compute.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/moose-lamb.png')] bg-cover bg-center"></div>
        <div class="bg-gray-500 rounded-xl bg-[url('./assets/logo-examples/victoria-baths.png')] bg-cover bg-center"></div>
      </div>
          <div  class="relative bg-gradient-to-b from-white/90 via-white to-white min-w-full h-1/4">
            <div class="relative flex flex-col gap-20 items-center max-w-screen-xl px-8 mt-40 mx-auto md:flex-row sm:px-6">
              <div class="text-left w-full sm:w-3/5 flex flex-col items-center sm:items-start gap-8">
                <h1 class="font-black text-5xl sm:text-6xl">
                  Your new logo for the price of a coffee
                </h1>
                <h2 class="font-black text-2xl">
                  Save time and money, get your new logo in seconds
                </h2>
                <ul class="space-y-5 font-bold text-2xl">
                  <li>
                    ✍🏼 Upload your rough design
                  </li>
                  <li>
                    🎨 Choose a style and colours
                  </li>
                  <li>
                    ✅ Download your new logo 
                  </li>
                </ul>
                <router-link 
                to="/pricing" class="transition ease-in-out text-white justify-center uppercase shadow-lg bg-[#0079E3]/80 py-2 px-4 w-1/3 min-w-[210px] flex hover:scale-105" @click="trackGetStarted">get started<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#e8eaed"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"/></svg>
                </router-link>
            </div>
            <h2 class="font-black text-4xl w-full text-center px-8 md:hidden">Logo Examples</h2>
            <div class="w-4/5 md:w-2/5">
              <img src="./assets/hero-img.png">
            </div>
          </div>
          <div class="md:mt-40">
            <h2 class="font-black text-4xl mb-20 w-full text-center px-8 hidden md:inline-block">Logo Examples</h2>
            <div class="flex flex-col md:flex-row justify-center items-center w-full text-4xl text-white align-middle">
              <img src="./assets/logo-examples/angler-example.png" class="w-4/5 md:w-1/3">
              <img src="./assets/logo-examples/padel-example.png" class="w-4/5 md:w-1/3">
              <img src="./assets/logo-examples/close-shave-example.png" class="w-4/5 md:w-1/3">
            </div>
          </div>
          <div class="flex flex-col gap-10 justify-center items-center mt-44">
            <h2 class="font-black text-4xl w-full text-center px-8">What our customers say...</h2>
            <div id="reviews" class="flex flex-col justify-center items-center text-center h-full space-y-20 lg:flex-row lg:space-x-20 lg:space-y-0 mb-12">
              <div class="transition items-center ease-in-out duration-700 bg-white h-full border border-[#0079E3] text-black rounded-lg px-5 font-sans w-2/3 justify-items-center lg:w-1/4 hover:scale-105">
                <div class="mt-5 mb-2">⭐️⭐️⭐️⭐️⭐️</div>
                "Logo AI is unbelievable! Did a very rough sketch of a new logo for my brand and uploaded it. It gave me a professional graphic back in a few seconds. Would deffo recommend"
                <div class="flex my-3 space-x-2 px-4">
                  <p class="font-bold">Gracie</p>
                  <span class="flex uppercase justify-between gap-1 text-nowrap text-xs align-middle items-center text-[#b6b5b5]">
                    <svg xmlns="http://www.w3.org/2000/svg"
                    height="18px"
                    viewBox="0 -960 960 960"
                    width="18px"
                    fill="#b6b5b5">
                    <path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56
                    216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54
                    127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5
                    156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134
                    0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
                    </svg>
                    verified purchase
                  </span>
                </div>
              </div>
              <div class="transition ease-in-out duration-700 bg-white h-4/5 border border-[#0079E3] text-black rounded-lg px-5 font-sans w-2/3 justify-items-center justify-between lg:w-1/4 hover:scale-105">
                <div class="mt-5 mb-2">⭐️⭐️⭐️⭐️⭐️</div>
                "Would definitely recommend Logo AI. I downloaded a new logo, perfect for my company, having spent £4.50 total 😳"
                <div class="flex my-3 space-x-2 px-4">
                  <p class="font-bold">Mark</p>
                  <span class="flex uppercase justify-between gap-1 text-nowrap text-xs align-middle items-center text-[#b6b5b5]">
                    <svg xmlns="http://www.w3.org/2000/svg"
                    height="18px"
                    viewBox="0 -960 960 960"
                    width="18px"
                    fill="#b6b5b5">
                    <path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56
                    216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54
                    127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5
                    156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134
                    0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
                    </svg>
                    verified purchase
                  </span>
                </div>
              </div>
              <div class="transition ease-in-out duration-700 bg-white h-full border border-[#0079E3] text-black rounded-lg px-5 font-sans w-2/3 justify-items-center lg:w-1/4 hover:scale-105">
                <div class="mt-5 mb-2">⭐️⭐️⭐️⭐️⭐️</div>
                "Wow wow wow. I wanted some inspiration for my new brands logo, came here and uploaded some rough ideas. I think I got more than just inspiration!! I'll be using this logo for my brand! Very easy to use. 10/10"
                <div class="flex my-3 space-x-2 px-4">
                  <p class="font-bold">Ollie</p>
                  <span class="flex uppercase justify-between gap-1 text-nowrap text-xs align-middle items-center text-[#b6b5b5]">
                    <svg xmlns="http://www.w3.org/2000/svg"
                    height="18px"
                    viewBox="0 -960 960 960"
                    width="18px"
                    fill="#b6b5b5">
                    <path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56
                    216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54
                    127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5
                    156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134
                    0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
                    </svg>
                    verified purchase
                  </span>
                </div>
              </div>
            </div>
            <router-link 
                to="/pricing" class="transition ease-in-out text-white justify-center uppercase shadow-lg bg-[#0079E3]/80 py-2 px-4 w-1/3 max-w-[250px] min-w-[210px] flex mb-40 hover:scale-105">get started<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#e8eaed"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"/></svg>
                </router-link>
          </div>       
        </div>
    </div>
  </template>

<script>

export default {
  name: 'home',
  data() {
    return {
      email: '',
    }
  },
  methods: {
    submit() {
      this.$emit('submit', this.email);
      console.log(this.email);
    },
    trackGetStarted() {
      if (this.$gtag) {
        this.$gtag.event('click', {
          event_category: 'user',
          event_label: 'get_started',
          value: 1
        });
      } else {
        console.error('Google Analytics is not initialized');
      }
    }
  }
};

</script>